import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import FavouriteIcon from './FavouriteIcon';

const NetworkingIconComponent = ({
  dtmTag, id, handleClick, label, isAddedToMyNetwork, altSVG, classname, isDirectoryView
}) => {
  const attribute = { participationId: id };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      data-testid="Networking-Icon-Component"
      data-dtm={dtmTag}
      data-dtm-attributes={JSON.stringify(attribute)}
      className={classname || classnames(Classes.networkParticipantIcon, Classes.primaryButton, Classes.borderRadius)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <span>
        <FavouriteIcon
          isFavourited={isAddedToMyNetwork}
          altSVG={altSVG}
        />
        {
          !isDirectoryView
            ? <span>{label}</span>
            : (
              <div className="directory-favourite-icon">
                <span className="mobile-view-icon" />
                <span className="desktop-view-icon">{label}</span>
              </div>
            )
        }
      </span>
    </div>
  );
};

NetworkingIconComponent.propTypes = {
  classname: PropTypes.string,
  dtmTag: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isAddedToMyNetwork: PropTypes.bool.isRequired,
  altSVG: PropTypes.string.isRequired,
  isDirectoryView: PropTypes.bool
};

export default NetworkingIconComponent;
